// extracted by mini-css-extract-plugin
export default {"headerLink":"HeaderLinkMob_headerLink__YtdRI"};